
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Mérignac dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Mérignac certifiée Google Partner, accompagne les entreprises mérignacaises pour booster leur visibilité en ligne et conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Mérignac dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Mérignac certifiée Google Partner, accompagne les entreprises mérignacaises pour booster leur visibilité en ligne et conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
